(function(){
  var icons=[
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 8.25 12 3.75l8 4.5v7.5l-8 4.5-8-4.5z"/><path d="m4.4 8.45 7.6 4.3 7.6-4.3M12 12.75v7.15"/><path d="M1.5 11.25h3M1.5 14.25h2.25"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m12 2.75 2 1.35 2.38-.18.88 2.22 2.14 1.06-.36 2.36 1.41 1.94-1.41 1.94.36 2.36-2.14 1.06-.88 2.22-2.38-.18-2 1.35-2-1.35-2.38.18-.88-2.22-2.14-1.06.36-2.36-1.41-1.94 1.41-1.94-.36-2.36 2.14-1.06.88-2.22 2.38.18z"/><path d="m8.65 12.05 2.15 2.15 4.65-5.15"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9.25 3.5h5.5M10.25 3.5v3.1L8 8.9v9.35c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75V8.9l-2.25-2.3V3.5"/><path d="M8 11.25h8"/><path d="M19.25 3.75v4.5M17 6h4.5M19 12.5V15M17.75 13.75h2.5"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5.75 9.5S9 6.6 9 4.25a3.25 3.25 0 0 0-6.5 0C2.5 6.6 5.75 9.5 5.75 9.5z"/><circle cx="5.75" cy="4.25" r=".85"/><path d="M18.25 21.25s3.25-2.9 3.25-5.25a3.25 3.25 0 0 0-6.5 0c0 2.35 3.25 5.25 3.25 5.25z"/><circle cx="18.25" cy="16" r=".85"/><path d="M8.15 9.9c2.2 1.35 4.75.3 6.35 1.95 1.2 1.25.35 2.55 1.55 3.55"/></svg>'
  ];

  function upgradeTrustBar(){
    var trust=document.querySelector('#shopify-section-home .trust');
    if(!trust)return;

    var iconNodes=trust.querySelectorAll('.titem .ticon');
    iconNodes.forEach(function(icon,index){
      if(!icons[index])return;
      icon.innerHTML=icons[index];
      icon.setAttribute('aria-hidden','true');
      icon.setAttribute('data-an-trust-icon',String(index+1));
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',upgradeTrustBar);
  }else{
    upgradeTrustBar();
  }

  window.addEventListener('pageshow',upgradeTrustBar);
  document.addEventListener('shopify:section:load',upgradeTrustBar);
})();
